// @ts-nocheck
import { Settings as SettingsIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { PageShell } from '@/components/layout/PageShell'
import { Card } from '@/components/ui/card'
import { CaseMembersConnected } from '@/features/case-members/CaseMembersConnected'
import { CaseDescription } from '@/features/case-overview/CaseDescription'
import { CaseSettings } from '@/features/case-overview/CaseSettings'
import { useCaseContext } from '../CaseContext'

export default function CaseSettingsPage() {
  const { t } = useTranslation()
  const { caseId, caseData, refetchCase } = useCaseContext()

  return (
    <PageShell
      layout="padded"
      icon={SettingsIcon}
      title={t('cases.settings.title')}
      summary={t('cases.settings.summary')}
    >
      <div className="space-y-6">
        {/* The overview header's Edit action lands here, so the description is editable here too. */}
        <Card className="p-5">
          <CaseDescription caseId={caseId} description={caseData.description} />
        </Card>
        <CaseSettings caseId={caseId} onCaseReset={refetchCase} />
        <CaseMembersConnected caseId={caseId} />
      </div>
    </PageShell>
  )
}
